import React, { Component } from "react";
import $ from "jquery";
import { ToastContainer, toast } from "react-toastify";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import { tokenVerification } from "./Utils";
import TranslationPanel from "./TranslationPanel";

class JournalContent extends Component {
  constructor(props) {
    super(props);

    this.state = {
      translationFor: null,
      disableAddQuestionButton: false,
      showLoader: false,
      hideDeletePopup: false,
      hideDeleteSuccessPopup: false,
      hideTextAreaPopup: false,
      fields: {
        scopeType: { name: "", id: "" },
        journalGroupId: { name: "", id: "" },
      },
      scopeTypeValues: [],
      journalGroupValue: [],
      title: "",
      scopeType: "",
      journalGroupId: "",
      showOptionTextArea: false,
      showThresholdLimitLabel: false,
      // showSelectAllCheckBox : false,
      selectedAllDays: [],
      daysOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
      typeName: "",
      journalGroupName: "",
      values: [],
      journalId: "",
      editable: true,
      editImageSrc: "./assets/images/edit.svg",
      selectedScopeGroup: "",
      selectedScopeType: "",
      user_editable: true,
      editedId: "-1",
      num: 0,

    };
    this.saveImageSrc = "./assets/images/baseline_save_white_24dp.png";
    this.editImageSrc = "./assets/images/edit2.png";
    this.answerTypeValues = [];
    this.state.healthSystemId = localStorage.getItem("healthSystemId");
    this.state.hospitalId = localStorage.getItem("hospitalId");
    this.state.serviceLineId = localStorage.getItem("serviceLineId");
    this.userDetails = JSON.parse(localStorage.getItem("user_details"));
    var user = JSON.parse(localStorage.getItem("user_details"));

    this.state.user = user;

    if (
      !this.state.healthSystemId ||
      this.state.healthSystemId == "null" ||
      this.state.healthSystemId == "Select HealthSystem"
    ) {
      this.state.healthSystemId = user["healthSystemId"];
    }
    if (
      !this.state.hospitalId ||
      this.state.hospitalId == "null" ||
      this.state.hospitalId == "Select Hospital"
    ) {
      this.state.hospitalId = user.hospitalId;
    }
    if (
      !this.state.serviceLineId ||
      this.state.serviceLineId == "null" ||
      this.state.serviceLineId == "Select ServiceLine"
    ) {
      this.state.serviceLineId = user.serviceLineId;
    }

    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    var thisController = this;
    setTimeout(() => {
      thisController.fetchScopeType();
      thisController.fetchAnswerType();
      thisController.fetchJournalWithId();
    }, 300);
  }
  deleteJournalItem = (id) => {
    let journalQuestionsData = this.state.values;
    let deleteApiViewController = this;
    var deleteConstructorVariables = this;

    if (id == "") {
      deleteApiViewController.setState({ deleteRow: true });
      deleteConstructorVariables.setState({ hideDeletePopup: false });
      deleteConstructorVariables.setState({ hideDeleteSuccessPopup: true });
      journalQuestionsData.splice(id, 1);
    } else {
      $.ajax({
        url: "/my-jeeva-api/delete-journal-item/" + id,

        method: "DELETE",
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token"),
        },
        success: function (res) {
          if (res.success === true) {
            deleteApiViewController.setState({ deleteRow: true });
            deleteConstructorVariables.setState({ hideDeletePopup: false });
            deleteConstructorVariables.notifyDelete();
            deleteConstructorVariables.state.values = [];
            deleteConstructorVariables.setState(
              deleteConstructorVariables.state
            );
            deleteConstructorVariables.fetchJournalItem();
          } else {
            // journalQuestionsData.notifyError();
          }
        },
        error: function (xhr) {
          if (xhr.status == 401) {
            window.location.href = "";
          }
        },
      });
    }
  };
  notifyDelete() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/done.svg"
          style={{ paddingRight: "0px" }}
          content=""
        />
        &nbsp;&nbsp;Question deleted successfully
      </b>,
      {
        position: "top-center",
      }
    );
  }

  fetchJournalWithId() {
    var fetchController = this;

    $.ajax({
      url: "/my-jeeva-api/fetch-journal-with-id",

      method: "GET",
      data: {
        id: this.props.location.state.currentJournalId,
      },
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },
      success: function (res) {
        if (res.success == true) {
          fetchController.state.showLoader = true;
          fetchController.state.editable = false;
          fetchController.state.user_editable = false;
          fetchController.setState(fetchController.state);
          if (res.result != null) {
            fetchController.state.journalId = res.result.id;
            fetchController.state.title = res.result.title;
            fetchController.state.scopeType = res.result.type;
            fetchController.state.journalGroupId = res.result.journalGroupId;
            fetchController.setState(fetchController.state);
            fetchController.state.journalGroupName =
              res.result.journalGroupName;
            fetchController.state.typeName = res.result.typeName;
            var scopeType = fetchController.state.scopeType;
            if (scopeType == "SERVICE_LINE") {
              fetchController.fetchScopeGroups(scopeType);
            } else if (scopeType == "TREATMENT") {
              fetchController.fetchScopeGroups(scopeType);
            }
          }
          fetchController.setState(fetchController.state);
          fetchController.fetchJournalItem();
        }
      },
    });
  }
  fetchJournalItem() {
    var fetchController = this;
    $.ajax({
      url: "/my-jeeva-api/fetch-journal-item",

      method: "GET",
      data: {
        userEmail: JSON.parse(localStorage.getItem("user_details"))["emailId"],
        journalId: fetchController.state.journalId,
      },
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },
      success: function (res) {
        if (res.success == true) {
          if (res.result.length == 0) {
            fetchController.state.user_editable = true;
            fetchController.setState(fetchController.state);
          } else {
            fetchController.state.user_editable = false;
            fetchController.state.values = res.result;
            for (var i = 0; i < res.result.length; i++) {
              fetchController.state.values[i]["optionsCopy"] = [];
              fetchController.state.values[i].optionsCopy =
                res.result[i].options.split(",");
            }
            fetchController.setState(fetchController.state);
          }
        }
      },
    });
  }
  editUserValue = () => {
    this.state.editable = true;
    this.setState(this.state);
  };
  editValue = (e) => {
    e.preventDefault();
    this.state.user_editable = true;
    this.setState(this.state);
  };
  fetchScopeGrpHS = (scopeType) => {
    var fetchScopeGrp = this;
    fetchScopeGrp.state.loadView = false;
    fetchScopeGrp.state.journalGroupValue = [];
    $.ajax({
      url: "/my-jeeva-api/fetch-journal-group",

      method: "GET",
      data: {
        journalScope: scopeType,
      },
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },
      success: function (res) {
        if (res.success === true) {
          for (var i = 0; i < res.result.length; i++) {
            fetchScopeGrp.state.journalGroupValue.push({
              name: res.result[i].name,
              value: res.result[i].id,
            });
          }
          if (fetchScopeGrp.state.journalGroupId == "") {
            fetchScopeGrp.state.journalGroupId = {
              name: res.result[0].name,
              value: res.result[0].id,
            };
          }
          fetchScopeGrp.setState(fetchScopeGrp.state);
        }
      },
    });
  };
  notifyError() {
    toast.dismiss();
    toast(
      <b style={{ color: "red" }}>Oops! Error occurred.Please try again</b>,
      {
        position: "top-center",
        color: "red",
      }
    );
  }
  fetchScopeGrpHospital = (scopeType) => {
    var fetchScopeGrp = this;
    fetchScopeGrp.state.loadView = false;
    fetchScopeGrp.state.journalGroupValue = [];
    var healthSystem = JSON.parse(localStorage.getItem("user_details"))[
      "healthSystemId"
    ];
    $.ajax({
      url: "/my-jeeva-api/fetch-journal-group",

      method: "GET",
      data: {
        journalScope: scopeType,
        healthSystemId: healthSystem,
      },
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },
      success: function (res) {
        if (res.success === true) {
          for (var i = 0; i < res.result.length; i++) {
            fetchScopeGrp.state.journalGroupValue.push({
              name: res.result[i].name,
              value: res.result[i].id,
            });
          }
          if (fetchScopeGrp.state.journalGroupId == "") {
            fetchScopeGrp.state.journalGroupId = {
              name: res.result[0].name,
              value: res.result[0].id,
            };
          }
          fetchScopeGrp.setState(fetchScopeGrp.state);
        } else {
          fetchScopeGrp.notifyFailedToLoad(res.result);
        }
      },
    });
  };
  fetchScopeGrpSL = (scopeType) => {
    var fetchScopeGrp = this;
    fetchScopeGrp.state.loadView = false;
    fetchScopeGrp.state.journalGroupValue = [];
    if (window.SCOPE_VALUE.CURRENT >= window.SCOPE_VALUE.HOSPITAL_ADMIN) {
      var healthSystem = fetchScopeGrp.props.location.state.healthSystemId;
      var hospital = fetchScopeGrp.props.location.state.hospitalId;
    } else {
      var healthSystem = JSON.parse(localStorage.getItem("user_details"))[
        "healthSystemId"
      ];
      var hospital = JSON.parse(localStorage.getItem("user_details"))[
        "hospitalId"
      ];
    }
    var serviceLineId = fetchScopeGrp.userDetails["serviceLineId"]; //JSON.parse(localStorage.getItem("user_details"))["serviceLineId"]
    if (serviceLineId == "null" || serviceLineId == null) {
      serviceLineId = "00000000-0000-0000-0000-000000000000";
    }
    $.ajax({
      url: "/my-jeeva-api/fetch-journal-group",

      method: "GET",
      data: {
        journalScope: scopeType,
        healthSystemId: healthSystem,
        hospitalId: hospital,
        serviceLineId: serviceLineId,
      },
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },
      success: function (res) {
        if (res.success === true) {
          var scopeGroupInfo = res.result;
          for (var i = 0; i < res.result.length; i++) {
            var serviceLineId = fetchScopeGrp.userDetails["serviceLineId"];
            var userRole = fetchScopeGrp.userDetails["userRole"];
            if (userRole == "SERVICELINE_ADMIN" || userRole == "PHYSICIAN") {
              if (scopeGroupInfo[i].id == serviceLineId) {
                fetchScopeGrp.state.journalGroupValue.push({
                  name: res.result[i].name,
                  value: res.result[i].id,
                });
              }
            } else {
              fetchScopeGrp.state.journalGroupValue.push({
                name: res.result[i].name,
                value: res.result[i].id,
              });
            }
          }
          if (fetchScopeGrp.state.journalGroupId == "") {
            fetchScopeGrp.state.journalGroupId = {
              name: res.result[0].name,
              value: res.result[0].id,
            };
          }
          fetchScopeGrp.setState(fetchScopeGrp.state);
        } else {
          fetchScopeGrp.notifyFailedToLoad(res.result);
        }
      },
    });
  };
  notifyFailedToLoad(response) {
    toast.dismiss();
    toast(<b style={{ color: "red" }}>{response}</b>, {
      position: "top-center",
      color: "red",
    });
  }

  fetchScopeGroups = (scopeType) => {
    var thisController = this;
    thisController.state.loadView = false;
    var userRole = JSON.parse(localStorage.getItem("user_details"))["userRole"];

    thisController.state.journalGroupValue = [];
    if (userRole == "HOSPITAL_ADMIN") {
      thisController.state.healthSystemId = JSON.parse(
        localStorage.getItem("user_details")
      )["healthSystemId"];
      thisController.state.hospitalId = JSON.parse(
        localStorage.getItem("user_details")
      )["hospitalId"];
      thisController.setState(thisController.state);
    }
    if (window.SCOPE_VALUE.CURRENT == window.SCOPE_VALUE.HEALTHSYSTEM_ADMIN) {
      thisController.state.healthSystemId = JSON.parse(
        localStorage.getItem("user_details")
      )["healthSystemId"];
      thisController.state.hospitalId =
        thisController.props.location.state.hospitalId;
      thisController.setState(thisController.state);
    } else if (window.SCOPE_VALUE.CURRENT == window.SCOPE_VALUE.PHYSICIAN) {
      thisController.state.healthSystemId = JSON.parse(
        localStorage.getItem("user_details")
      )["healthSystemId"];
      thisController.state.hospitalId = JSON.parse(
        localStorage.getItem("user_details")
      )["hospitalId"];
      thisController.state.serviceLineId = JSON.parse(
        localStorage.getItem("user_details")
      )["serviceLineId"];
    }

    var healthSystem = thisController.state.healthSystemId;
    var hospital = thisController.state.hospitalId;
    var serviceLine = JSON.parse(localStorage.getItem("user_details"))[
      "serviceLineId"
    ];
    if (serviceLine == "null" || serviceLine == null) {
      serviceLine = "00000000-0000-0000-0000-000000000000";
    }

    if (userRole == "PHYSICIAN" && scopeType == "TREATMENT") {
      var providerId = JSON.parse(localStorage.getItem("user_details"))[
        "userId"
      ];
      var hospitalId = JSON.parse(localStorage.getItem("user_details"))[
        "hospitalId"
      ];
      $.ajax({
        url: "/my-jeeva-api/procedure-treatment",
        method: "GET",
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token"),
        },
        data: {
          providerId: providerId,
          hospitalId: hospitalId,
        },
        success: function (res) {
          if (res.success === true) {
            thisController.state.showLoader = true;
            thisController.setState(thisController.state);
            var scopeGroupInfo = res.result;
            scopeGroupInfo = scopeGroupInfo.filter(procedure => !procedure.isDeactivated).sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()));
            for (var i = 0; i < scopeGroupInfo.length; i++) {
              if(scopeGroupInfo[i].createdBy != null && scopeGroupInfo[i].createdBy === thisController.userDetails["emailId"]){

              if (scopeGroupInfo[i].name == thisController.state.journalGroupName) {
                thisController.state.journalGroupValue.unshift({
                  name: scopeGroupInfo[i].name,
                  value: scopeGroupInfo[i].id,
                });
              } else {
                thisController.state.journalGroupValue.push({
                  name: scopeGroupInfo[i].name,
                  value: scopeGroupInfo[i].id,
                });
              }
            }
              thisController.setState(thisController.state);
            }
          }
        },
        error: function (xhr) {
          if (xhr.status == 401) {
            window.location.href = "";
          }
        },
      });
    } else if (userRole == "SERVICELINE_ADMIN" && scopeType == "TREATMENT") {
      var healthSystemId = JSON.parse(localStorage.getItem("user_details"))[
        "healthSystemId"
      ];
      var hospitalId = JSON.parse(localStorage.getItem("user_details"))[
        "hospitalId"
      ];
      var serviceLineId = JSON.parse(localStorage.getItem("user_details"))[
        "serviceLineId"
      ];
      $.ajax({
        url: "/my-jeeva-api/procedure",
        method: "GET",
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token"),
        },
        data: {
          healthSystemId: healthSystemId,
          hospitalId: hospitalId,
          serviceLineId: serviceLineId,
        },
        success: function (res) {
          if (res.success === true) {
            thisController.state.showLoader = true;
            thisController.setState(thisController.state);
            var scopeGroupInfo = res.result.filter(procedure => !procedure.isDeactivated);
            for (var i = 0; i < scopeGroupInfo.length; i++) {
              if (scopeGroupInfo[i].name == thisController.state.journalGroupName) {
                thisController.state.journalGroupValue.unshift({
                  name: scopeGroupInfo[i].name,
                  value: scopeGroupInfo[i].id,
                });
              } else {
                thisController.state.journalGroupValue.push({
                  name: scopeGroupInfo[i].name,
                  value: scopeGroupInfo[i].id,
                });
              }
              thisController.setState(thisController.state);
            }
          }
        },
        error: function (xhr) {
          if (xhr.status == 401) {
            window.location.href = "";
          }
        },
      });
    } else {
      $.ajax({
        url: "/my-jeeva-api/fetch-journal-group",
        method: "GET",
        data: {
          journalScope: scopeType,
          healthSystemId: healthSystem,
          hospitalId: hospital,
          serviceLineId: serviceLine,
          userRole: userRole,
        },
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token"),
        },
        success: function (res) {
          if (res.success === true) {
            thisController.state.loadView = true;
            var scopeGroupInfo = res.result;
            scopeGroupInfo = scopeGroupInfo.filter(
              (procedure) => !procedure.isDeactivated
            );
            for (var i = 0; i < scopeGroupInfo.length; i++) {
              var userRole = JSON.parse(localStorage.getItem("user_details"))[
                "userRole"
              ];
              if (userRole == "SERVICELINE_ADMIN" || userRole == "PHYSICIAN") {
                var serviceLineId = JSON.parse(
                  localStorage.getItem("user_details")
                )["serviceLineId"];
                if (scopeGroupInfo[i].id == serviceLineId) {
                  thisController.state.journalGroupValue.push({
                    name: scopeGroupInfo[i].name,
                    value: scopeGroupInfo[i].id,
                  });
                  thisController.setState(thisController.state);
                }
              } else if (
                scopeGroupInfo[i].name == thisController.state.journalGroupName
              ) {
                thisController.state.journalGroupValue.unshift({
                  name: scopeGroupInfo[i].name,
                  value: scopeGroupInfo[i].id,
                });
              } else {
                thisController.state.journalGroupValue.push({
                  name: scopeGroupInfo[i].name,
                  value: scopeGroupInfo[i].id,
                });
              }
            }

            if (thisController.state.journalGroupId == "") {
              thisController.state.journalGroupId = {
                name: scopeGroupInfo[0].name,
                value: scopeGroupInfo[0].id,
              };
            }
            thisController.setState(thisController.state);
          }
        },
      });
    }
  };
  fetchScopeType = () => {
    let thisController = this;
    thisController.state.loadView = false;
    thisController.state.scopeTypeValues = [];
    $.ajax({
      url: "/my-jeeva-api/journal-type",
      type: "GET",

      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },
      success: function (res) {
        thisController.state.loadView = true;
        if (res.success === true) {
          for (var i = 0; i < res.result.length; i++) {
            if (res.result[i]['name'] != "SERVICE_LINE") {
              thisController.state.scopeTypeValues.push({
                name: res.result[i].code,
                value: res.result[i].name,
              });
            }
          }
          if (thisController.state.scopeType == "") {
            thisController.state.scopeType = {
              name: res.result[0].code,
              value: res.result[0].name,
            };
          }
          thisController.setState(thisController.state);
        } else {
          thisController.notifyFailedToLoad(res.result);
        }
      },
      error: function (xhr) {
        if (xhr.status == 401) {
          tokenVerification();
        }
      },
    });
  };

  fetchAnswerType = () => {
    var fetchDataContoller = this;
    $.ajax({
      url: "/my-jeeva-api/journal-answer-type",

      method: "GET",
      headers: {
        Authorization: "Bearer " + localStorage.getItem("access_token"),
      },
      success: function (res) {
        if (res.success === true) {
          fetchDataContoller.state.showOptionTextArea = false;
          fetchDataContoller.state.showThresholdLimitLabel = false;
          // fetchDataContoller.state.showSelectAllCheckBox = false
          fetchDataContoller.setState(fetchDataContoller.state);
          var loadAnswerType = res.result;
          var numberOfloadAnswerType = loadAnswerType.length;
          fetchDataContoller.answerTypeValues = [];
          for (var i = 0; i < numberOfloadAnswerType; i++) {
            fetchDataContoller.answerTypeValues[i] = loadAnswerType[i];
          }
        }
      },
    });
  };
  

  saveJournalInfoApi = (props, e) => {
    this.state.editedId = "-1";
    this.setState(this.state);
    var saveController = this;

    var title = document.getElementById("journalTitle").value.trim();

    var titlePattern = new RegExp(/^([a-zA-Z0-9 /''()#.,-])*$/);
    if (title == "") {
      saveController.notifyEmptyFields();
    } else if (!titlePattern.test(title)) {
      saveController.notifyImproperTitle();
    } else {
      var addJournalData = {
        title: title,
        createdByEmail: JSON.parse(localStorage.getItem("user_details"))[
          "emailId"
        ],
        createdByName: JSON.parse(localStorage.getItem("user_details"))["name"],
        type: document.getElementById("typeId").value,
        journalGroupId: document.getElementById("journalGroupId").value,
      };
      $.ajax({
        url: "/my-jeeva-api/add-journal",

        method: "POST",
        data: JSON.stringify(addJournalData),
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token"),
          "Content-Type": "application/json",
        },

        success: function (res) {
          if (res.success === true) {
            saveController.state.editable = true;
            saveController.notifyJournalAdded();
            saveController.fetchJournalWithId();
            saveController.setState({ disabled: false });
          } else {
            saveController.notifyFailedResponse(res.result);
          }
        },
        error: function (xhr) {
          if (xhr.status == 401) {
            window.location.href = "";
          }
        },
      });
    }
  };
  notifyFailedResponse(response) {
    toast.dismiss();
    toast(<b style={{ color: "red" }}>{response}</b>, {
      position: "top-center",
      color: "red"

    });
  }
  notifyImproperDate() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/warn.svg"
          style={{ paddingRight: "0px", height: "20px", width: "20px" }}
          content=""
        />
        &nbsp;&nbsp;Kindly enter a valid date.
      </b>,
      {
        position: "top-center",
      }
    );
  }

  saveJournalItemInfoApi = (index, e) => {
    this.state.editedId = "-1";
    this.setState(this.state);
    var saveController = this;
    var question = document
      .getElementById("questionId" + index)
      .innerText.trim();
    var label = document.getElementById("labelId" + index).innerText.trim();
    var answerType = document.getElementById("answerTypeId" + index).value;
    var options = document.getElementById("optionId" + index).innerHTML;
    var threshold = "";
    var lowerThreshold = "";
    var optionsarray = options.split(",");
    var qnPattern = new RegExp(/^([a-zA-Z0-9.,?#_/\s])*$/);
    if (answerType == "INTEGER") {
      // threshold = document.getElementById("thresholdId" + index).value;
      // lowerThreshold = document.getElementById("lowerThresholdId" + index).value;
    }
    var addJournalItemData = {
      options: options,
      type: answerType,
      question: question,
      label: label,
      journalId: saveController.state.journalId,
      typeName: document.getElementById("answerTypeId" + index).options[
        document.getElementById("answerTypeId" + index).selectedIndex
      ].text,
      threshold: threshold,
      lowerThreshold: lowerThreshold
    };

    if (question == "" || answerType == "" || label == "") {
      saveController.notifyEmptyFields();
      saveController.makeCelledit(index);
    } else if (answerType == "MULTISELECT" && options == "") {
      saveController.notifyEmptyFields();
    } else if (answerType == "SELECT" && options == "") {
      saveController.notifyEmptyFields();
    } else if (
      answerType == "MULTISELECT" &&
      (optionsarray.length == 1 || optionsarray[1] == "")
    ) {
      saveController.notifyNotProperOptions();
    } else if (
      answerType == "SELECT" &&
      (optionsarray.length == 1 || optionsarray[1] == "")
    ) {
      saveController.notifyNotProperOptions();
    } else {
      $.ajax({
        url: "/my-jeeva-api/add-journal-item",

        method: "POST",
        data: JSON.stringify(addJournalItemData),
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token"),
          "Content-Type": "application/json",
        },

        success: function (res) {
          if (res.success === true) {
            saveController.state.disableAddQuestionButton = false;
            saveController.notifyQnAdded();
            saveController.fetchJournalItem();
            saveController.setState({ disabled: false });
          } else {
            saveController.notifyFailedResponse(res.result);
          }
        },
        error: function (xhr) {
          if (xhr.status == 401) {
            window.location.href = "";
          }
        },
      });
    }
  };


  notifyImproperQuestion() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/warn.svg"
          style={{ paddingRight: "0px", height: "20px", width: "20px" }}
          content=""
        />
        &nbsp;&nbsp;Kindly avoid special characters other than '?'.
      </b>,
      {
        position: "top-center",
      }
    );
  }
  notifyQnAdded() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/done.svg"
          style={{ paddingRight: "0px" }}
          content=""
        />
        &nbsp;&nbsp;Question added successfully
      </b>,
      {
        position: "top-center",
      }
    );
  }
  notifyJournalAdded() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/done.svg"
          style={{ paddingRight: "0px" }}
          content=""
        />
        &nbsp;&nbsp;New journal created successfully
      </b>,
      {
        position: "top-center",
      }
    );
  }

  handleChange = (e) => {
    document.getElementById("questionId").innerHTML = e.target.value;
    this.setState(this.state);
  };

  handleAddQuestionButtonClick() {
    this.state.disableAddQuestionButton = true;
    this.state.user_editable = false;
    this.state.showOptionTextArea = false;
    this.state.showThresholdLimitLabel = false;
    // this.state.showSelectAllCheckBox = false;
    this.setState(this.state);
    this.setState((prevState) => ({
      values: [...prevState.values, { optionsCopy: [] }],
    }));
  }

  removeClick(i) {
    let values = [...this.state.values];
    values.splice(i, 1);
    this.setState({ values });
  }

  handleSubmit(event) {
    event.preventDefault();
  }

  onChangeScopeType = (e) => {
    this.state.scopeType = e.target.value;
    this.setState(this.state);
    var scopeType = e.target.value;
    this.fetchScopeGroups(scopeType);
    this.setState(this.state);
  };
  onChangeGroupValue = (e) => {
    this.state.journalGroupName =
      e.nativeEvent.target[e.nativeEvent.target.selectedIndex].text;
    this.state.journalGroupId = e.target.value;
    this.setState(this.state);
  };

  makeCelledit(index) {
    this.markAsBeingEdited(this.state.values[index].id);
  }

  markAsBeingEdited(id) {
    this.state.editedId = id;
    this.state.disableAddQuestionButton = true;
    var stateObj = this.state;
    this.setState(stateObj);
  }
  notifyEmptyFields() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/warn.svg"
          style={{ paddingRight: "0px", height: "20px", width: "20px" }}
          content=""
        />
        &nbsp;&nbsp;Please fill all the fields before saving
      </b>,
      {
        position: "top-center",
      }
    );
  }
  updateJournalItemApi = (index) => {
    this.state.editable = false;
    this.setState(this.state);
    var updateController = this;
    var question = document
      .getElementById("questionId" + index)
      .innerText.trim();
    var label = document.getElementById("labelId" + index).innerText.trim();
    var answerType = document.getElementById("answerTypeId" + index).value;
    var options = document.getElementById("optionId" + index).innerHTML;
    var threshold = "";
    var lowerThreshold = "";
    var optionsarray = options.split(",");

    if (question == "" || answerType == "" || label == "") {
      updateController.notifyEmptyFields();
      updateController.makeCelledit(index);
    } else if (answerType == "MULTISELECT" && options == "") {
      updateController.notifyEmptyFields();
    } else if (answerType == "SELECT" && options == "") {
      updateController.notifyEmptyFields();
    } else if (
      answerType == "MULTISELECT" &&
      (optionsarray.length == 1 || optionsarray[1] == "")
    ) {
      updateController.notifyNotProperOptions();
    } else if (
      answerType == "SELECT" &&
      (optionsarray.length == 1 || optionsarray[1] == "")
    ) {
      updateController.notifyNotProperOptions();
    } else if (updateController.state.cumulativeType === true) {

    } else {
      if (answerType == "INTEGER") {
        // threshold = document.getElementById("thresholdId" + index).value;
        // lowerThreshold = document.getElementById("lowerThresholdId" + index).value;
      }
      var updatedData = {
        id: updateController.state.values[index].id,
        question: question,
        label: label,
        type: answerType,
        options: options,
        typeName: document.getElementById("answerTypeId" + index).options[
          document.getElementById("answerTypeId" + index).selectedIndex
        ].text,
        threshold: threshold,
        lowerThreshold: lowerThreshold
      };
      $.ajax({
        url: "/my-jeeva-api/update-journal-item",
        method: "PATCH",
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token"),
          "Content-Type": "application/json",
        },
        data: JSON.stringify(updatedData),
        contentType: "application/json; charset=UTF-8",
        success: function (res) {
          if (res.success === true) {
            updateController.state.showLoader = true;
            updateController.state.editedId = "-1";
            updateController.state.editable = true;
            updateController.state.disableAddQuestionButton = false;
            updateController.setState(updateController.state);
            updateController.notifyUpdate();
            updateController.fetchJournalWithId();
          } else {
            updateController.notifyFailedResponse(res.result);
          }
        },
        error: function (xhr) {
          if (xhr.status == 401) {
            window.location.href = "";
          }
        },
      });
    }
  };
  updateJournalApi = () => {
    var updateController = this;
    var title = updateController.state.title;

    var titlePattern = new RegExp(
      /^(?!^[^A-Za-z0-9]+$)[A-Za-z0-9\s!@#$%^&*()-_=+{}\[\]|\\;:'",<.>/?]+$/
    );

    updateController.state.typeName =
      document.getElementById("typeId").options[
        document.getElementById("typeId").selectedIndex
      ].text;

    updateController.state.journalGroupName =
      document.getElementById("journalGroupId").options[
        document.getElementById("journalGroupId").selectedIndex
      ].text;
    updateController.setState(updateController.state);
    var updatedData = {
      id: updateController.props.location.state.currentJournalId,
      title: title,
      createdByEmail: JSON.parse(localStorage.getItem("user_details"))[
        "emailId"
      ],
      createdByName: JSON.parse(localStorage.getItem("user_details"))["name"],
      type: updateController.state.scopeType,
      journalGroupId: updateController.state.journalGroupId,

      typeName: updateController.state.typeName,
      journalGroupName: updateController.state.journalGroupName,
    };
    if (title == "") {
      updateController.notifyEmptyFields();
    } else if (!titlePattern.test(title)) {
      updateController.notifyImproperTitle();
    } else {
      $.ajax({
        url: "/my-jeeva-api/update-journal",

        method: "PATCH",
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token"),
          "Content-Type": "application/json",
        },
        data: JSON.stringify(updatedData),
        contentType: "application/json; charset=UTF-8",
        success: function (res) {
          if (res.success === true) {
            updateController.state.editedId = "-1";
            updateController.state.user_editable = true;
            updateController.state.disabled = false;
            updateController.notifyJournalUpdate();
            updateController.fetchJournalWithId();
          } else {
            updateController.notifyFailedResponse(res.result);
          }
        },
        error: function (xhr) {
          if (xhr.status == 401) {
            window.location.href = "";
          }
        },
      });
    }
  };
  notifyJournalUpdate() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/done.svg"
          style={{ paddingRight: "0px" }}
          content=""
        />
        &nbsp;&nbsp;Journal updated successfully
      </b>,
      {
        position: "top-center",
      }
    );
  }
  notifyNotProperOptions() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/warn.svg"
          style={{ paddingRight: "0px", height: "20px", width: "20px" }}
          content=""
        />
        &nbsp;&nbsp;Please add more than one options
      </b>,
      {
        position: "top-center",
      }
    );
  }
  notifyImproperTitle() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/warn.svg"
          style={{ paddingRight: "0px", height: "20px", width: "20px" }}
          content=""
        />
        &nbsp;&nbsp;Kindly avoid special characters & provide a valid name
      </b>,
      {
        position: "top-center",
      }
    );
  }

  notifyUpdate() {
    toast.dismiss();
    toast(
      <b>
        <img
          src="assets/images/done.svg"
          style={{ paddingRight: "0px" }}
          content=""
        />
        &nbsp;&nbsp;Journal Item updated successfully
      </b>,
      {
        position: "top-center",
      }
    );
  }
  onHandleChangeAnswerType = (index, e) => {
    var answerType = document.getElementById("answerTypeId" + index).value;
    this.state.values[index].type = answerType;
    if (answerType == "SELECT" || answerType == "MULTISELECT") {
      this.state.showOptionTextArea = true;
      this.state.showThresholdLimitLabel = false;
    } else if (answerType === "INTEGER") {
      this.state.showThresholdLimitLabel = true;
      this.state.showOptionTextArea = false;
    }
    // else if(answerType === "DAYSOFWEEK"){
    //   this.state.showSelectAllCheckBox = true;
    // }
    else {
      this.state.showOptionTextArea = false;
      this.state.showThresholdLimitLabel = false
      // this.state.showSelectAllCheckBox = false;
    }
    this.setState(this.state);
  };
  onChangeTitle = (e) => {
    this.state.title = e.target.value;
    this.setState(this.state);
  };
  goBackFromSubTab = () => {
    var pageNum = this.props.location.state.pageNum;
    this.props.history.push({
      pathname: "/projectmgmt/journal",
    });
  };

  incNum = () => {
    var thisController = this;
    if (thisController.state.num < 10) {
      thisController.state.num = Number(thisController.state.num) + 1;
    }
    thisController.setState(thisController.state);
  };
  decNum = () => {
    var thisController = this;
    if (thisController.state.num > 0) {
      thisController.state.num = Number(thisController.state.num) - 1;
    }
    thisController.setState(thisController.state);
  };

  openDeletePopUp = (id) => {
    confirmAlert({
      title: "Confirm to Delete",
      message: "Are you sure you want to delete this question ? ",
      buttons: [
        {
          label: "Yes",
          onClick: () => this.deleteJournalItem(id),
        },
        {
          label: "No",
        },
      ],
    });
  };

  handleDeleteQuestionButtonClick(id) {
    this.state.disableAddQuestionButton = false;

    if (id) {
      this.openDeletePopUp(id);
    } else {
      this.state.values = [];
      this.setState(this.state);
      this.fetchJournalItem();
    }
  }

  handleSelectAllDays = (e) => {
    if (e.target.checked) {
      this.setState({ selectedDays: this.state.daysOfWeek });
    } else {
      this.setState({ selectedDays: [] });
    }
  };

  render() {
    return (
      <div style={{ background: "#F9F9FB" }} id="scheduleJournal">
        {this.state.translationFor && (
          <TranslationPanel
            entityType={this.state.translationFor.entityType}
            entityId={this.state.translationFor.entityId}
            title={this.state.translationFor.title}
            fields={this.state.translationFor.fields}
            sourceFields={this.state.translationFor.sourceFields}
            procedureId={typeof this.state.journalGroupId === 'object' ? this.state.journalGroupId.id : this.state.journalGroupId}
            onClose={() => {
              this.setState({ translationFor: null });
              if (this.state.translationFor.entityType === "journal") {
                this.fetchJournalWithId();
              } else if (this.state.translationFor.entityType === "journalItem") {
                this.fetchJournalItem();
              }
            }}
          />
        )}
        <link rel="stylesheet" href="assets/css/ReactToastify.css" />
        <link
          rel="stylesheet"
          href="assets/css/React_Table_CSS/react-table.css"
        />

        <link href="assets/css/ej2-base.css" rel="stylesheet" />
        <link href="assets/css/ej2-react-buttons.css" rel="stylesheet" />
        <link href="assets/css/ej2-react-popups.css" rel="stylesheet" />
        <link href="assets/css/ej2-inputs.css" rel="stylesheet" />
        <link href="assets/css/screenResolution.css" rel="stylesheet" />
        <link
          rel="stylesheet"
          href="plugins/font-awesome/css/font-awesome.min.css"
        />
        <link rel="stylesheet" href="assets/fonts/flat-icon/flaticon.css" />
        <link rel="stylesheet" href="plugins/select2/select2.min.css" />
        <link rel="stylesheet" href="assets/css/toggleButton.css" />
        <link rel="stylesheet" href="./assets/css/styles.css" />

        <div className="content-header">
          <div>
            <link rel="stylesheet" href="assets/css/ReactToastify.css" />
            <ToastContainer className="Toast-at-center" />

            <div className="row">
              <div className="col-sm-4" Align="left">
                <img
                  src="assets/images/arrow.svg"
                  style={{ paddingRight: "30%", cursor: "pointer" }}
                  onClick={this.goBackFromSubTab}
                />
              </div>

              <div
                className="col-sm-4"
                style={{ display: "flex", justifyContent: "center" }}
              >
                <h6
                  className="nav-item"
                  style={{
                    color: "#282a65",
                    marginLeft: "1vw",
                  }}
                >
                  New Journal
                </h6>
              </div>
              <div className="col-sm-4"></div>
            </div>
            <div className="card-body p-0 mb-25">
              <div className="tab-content col-12 p-0">
                <div
                  className="card card-primary mt-3"
                  style={{ height: "80%" }}
                >
                  <div
                    style={{ marginLeft: "1vw", marginTop: "2vw" }}
                    className="raiseTicketLable"
                  >
                    <div className="row">
                      <div className="col-sm-6"></div>
                      <div className="col-sm-6" Align="right">
                        <button
                          style={{
                            backgroundColor: "#ffffff",
                            border: "none",
                            marginTop: "-9px",
                            marginLeft: "-6px",
                          }}
                          onClick={this.userDetails["userRole"] === "PHYSICIAN" &&
                            JSON.parse(localStorage.getItem('user_details')).emailId !== localStorage.getItem("journalCreatedBy") ? null :
                            this.state.editable
                              ? this.updateJournalApi
                              : this.editUserValue
                          }
                        >
                          <img
                            className="img-responsive"
                            style={{
                              marginTop: "6px",
                              backgroundColor: this.userDetails["userRole"] === "PHYSICIAN" &&
                                JSON.parse(localStorage.getItem('user_details')).emailId !== localStorage.getItem("journalCreatedBy")
                                ? "#282a6596"
                                : "#282a65",
                              borderRadius: "5px",
                              padding: "1px",
                            }}
                            disabled={this.userDetails["userRole"] === "PHYSICIAN" &&
                              JSON.parse(localStorage.getItem('user_details')).emailId !== localStorage.getItem("journalCreatedBy")}

                            src={
                              this.state.editable
                                ? this.saveImageSrc
                                : this.editImageSrc
                            }
                          />
                        </button>
                        {this.state.journalId &&
                          this.state.journalId !== "" && (
                            <button
                              title="Edit translations"
                              style={{
                                backgroundColor: "#ffffff",
                                border: "none",
                                marginLeft: "6px",
                                cursor: "pointer",
                                fontSize: "16px",
                              }}
                              onClick={() =>
                                this.setState({
                                  translationFor: {
                                    entityType: "journal",
                                    entityId: this.state.journalId,
                                    title: this.state.title || "Journal",
                                    fields: [
                                      { name: "title", label: "Title", rows: 1 },
                                    ],
                                    sourceFields: {
                                      title: this.state.title,
                                    },
                                  },
                                })
                              }
                            >
                              <img className="img-responsive" src="./assets/images/translate_white_24dp.svg" alt="translate" style={{ marginTop: "6px", backgroundColor: "#282a65", borderRadius: "5px", padding: "1px", width: "24px", height: "24px" }} />
                            </button>
                          )}
                      </div>
                    </div>
                    <div className="row" Align="left">
                      <div className="col-sm-6">
                        <div className="row">
                          <div className="col-sm-4">
                            <label>Title</label>
                          </div>
                          <div className="col-sm-1">:</div>
                          <div className="col-sm-7">
                            <input
                              className="col-sm-8"
                              type="text"
                              value={this.state.title}
                              onChange={(e) => this.onChangeTitle(e)}
                              name="name"
                              id="journalTitle"
                              placeholder="Enter Title"
                              disabled={!this.state.editable}
                              style={{
                                borderBottom: !this.state.editable
                                  ? "1px solid #ffffff"
                                  : "1px solid #b2b2b2",
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <br />

                    <div className="row" Align="left">
                      <div className="col-sm-6">
                        <div className="row">
                          <div className="col-sm-4">
                            <label>Scope Type</label>
                          </div>
                          <div className="col-sm-1">:</div>
                          <div className="col-sm-7">
                            <div
                              className="textarea"
                              style={{
                                display: this.state.editable ? "none" : "block",
                                background: "white",
                                height: "2.7em",
                                resize: "none",
                                paddingLeft: "2px",
                                paddingTop: "6px",
                                width: "98%",
                              }}
                            >
                              {this.state.typeName}
                            </div>
                            <select
                              className="col-sm-8"
                              disabled={!this.state.editable}
                              name="typeId"
                              id="typeId"
                              value={this.state.scopeType}
                              onChange={(e) => this.onChangeScopeType(e)}
                              style={{
                                display: this.state.editable ? "block" : "none",
                                padding: "0.375rem 0.75rem",
                                background: "white",
                                borderBlockColor: "rgb(178, 178, 178)",
                                borderRadius: "5px",
                                height: "32px",
                              }}
                            >
                              {this.state.scopeTypeValues.map((typeId) => (
                                <option value={typeId.value}>
                                  {typeId.name}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>
                      </div>

                      <div className="col-sm-6">
                        <div className="row">
                          <div className="col-sm-4">
                            <label>Scope Group</label>
                          </div>
                          <div className="col-sm-1">:</div>
                          <div className="col-sm-7">
                            <div
                              className="textarea"
                              style={{
                                display: this.state.editable ? "none" : "block",
                                background: "white",
                                height: "2.7em",
                                resize: "none",
                                paddingLeft: "2px",
                                paddingTop: "6px",
                                width: "auto",
                              }}
                            >
                              {this.state.journalGroupName}
                            </div>
                            <select
                              className="col-sm-8"
                              disabled={!this.state.editable}
                              name="journalGroupId"
                              id="journalGroupId"
                              value={this.state.journalGroupId}
                              onChange={(e) => this.onChangeGroupValue(e)}
                              style={{
                                display: this.state.editable ? "block" : "none",
                                padding: "0.375rem 0.75rem",
                                background: "white",
                                borderBlockColor: "rgb(178, 178, 178)",
                                borderRadius: "5px",
                                height: "32px",
                              }}
                            >
                              {this.state.journalGroupValue.map(
                                (journalGroupKey) => (
                                  <option value={journalGroupKey.value}>
                                    {journalGroupKey.name}
                                  </option>
                                )
                              )}
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <hr />
                  <div
                    style={{
                      overflowY: "scroll",
                      height: "46vh",
                      overflowX: "hidden",
                    }}
                  >
                    <div>
                      {this.state.values.map((el, i) => (
                        <div key={i}>
                          <div>
                            <div>
                              <div
                                className="row"
                                style={{ marginTop: "4vw", marginLeft: "1vw" }}
                              >
                                <div className="col-sm-9" Align="left">
                                  <div className="col-sm-2">
                                    <label> Question:</label>
                                  </div>
                                  <div
                                    className="textarea"
                                    disabled={!this.state.user_editable}
                                    style={{
                                      textAlign: "left",
                                      background: "white",
                                      height: "4.7em",
                                      resize: "none",
                                      paddingLeft: "2px",
                                      paddingTop: "6px",
                                      width: "90%",
                                      fontSize: "1.5em",
                                      border:
                                        this.state.values[i].id == undefined ||
                                          this.state.values[i].id ==
                                          this.state.editedId
                                          ? "1px solid #D2D4DC"
                                          : "none",
                                      borderRadius:
                                        this.state.values[i].id == undefined ||
                                          this.state.values[i].id ==
                                          this.state.editedId
                                          ? "6px"
                                          : "none",
                                    }}
                                    id={"questionId" + [i]}
                                    contentEditable={
                                      !(this.state.values[i].id == undefined
                                        ? false
                                        : this.state.values[i].id !=
                                        this.state.editedId)
                                        ? "plaintext-only"
                                        : false
                                    }
                                  >
                                    {this.state.values[i].question}
                                  </div>
                                </div>
                                {/* <div className="col-sm-3">
                                  <button
                                    style={{
                                      backgroundColor: "#ffffff",
                                      border: "none",
                                      marginTop: "-9px",
                                      marginLeft: "-6px",
                                    }}
                                  >
                                    <img
                                      className="img-responsive"
                                      title={
                                        this.state.values[i].id == undefined ||
                                          this.state.values[i].id ==
                                          this.state.editedId
                                          ? "Save"
                                          : "Edit"
                                      }
                                      style={{
                                        marginTop: "6px",
                                        backgroundColor: "#282a65",
                                        borderRadius: "5px",
                                        padding: "1px",
                                      }}
                                      src={
                                        this.state.values[i].id == undefined
                                          ? this.saveImageSrc
                                          : this.state.values[i].id !=
                                            this.state.editedId
                                            ? this.editImageSrc
                                            : this.saveImageSrc
                                      }
                                      onClick={(e) => {
                                        this.state.values[i].id == undefined
                                          ? this.saveJournalItemInfoApi(i)
                                          : this.state.values[i].id ==
                                            this.state.editedId
                                            ? this.updateJournalItemApi(i)
                                            : this.makeCelledit(i);
                                      }}
                                    />
                                  </button>
                                  <button
                                    style={{
                                      backgroundColor: "#ffffff",
                                      border: "none",
                                      marginTop: "-9px",
                                      marginLeft: "-6px",
                                    }}
                                    title="Delete"
                                  >
                                    <img
                                      className="img-responsive"
                                      src={
                                        "./assets/images/baseline_delete_white_24dp.png"
                                      }
                                      style={{
                                        marginTop: "6px",
                                        backgroundColor: "#282a65",
                                        borderRadius: "5px",
                                        padding: "1px",
                                      }}
                                      onClick={() =>
                                        this.handleDeleteQuestionButtonClick(
                                          this.state.values[i].id
                                        )
                                      }
                                    />
                                  </button>
                                </div> */}
                              </div>
                              <div
                                className="row"
                                style={{ marginTop: "4vw", marginLeft: "1vw" }}
                              >
                                <div className="col-sm-5" Align="left">
                                  <div className="col-sm-3">
                                    <label> Heading Label:</label>
                                  </div>
                                  <div
                                    className="textarea"
                                    disabled={!this.state.user_editable}
                                    style={{
                                      textAlign: "left",
                                      background: "white",
                                      height: "4.7em",
                                      resize: "none",
                                      paddingLeft: "2px",
                                      paddingTop: "6px",
                                      width: "90%",
                                      fontSize: "1.5em",
                                      border:
                                        this.state.values[i].id == undefined ||
                                          this.state.values[i].id ==
                                          this.state.editedId
                                          ? "1px solid #D2D4DC"
                                          : "none",
                                      borderRadius:
                                        this.state.values[i].id == undefined ||
                                          this.state.values[i].id ==
                                          this.state.editedId
                                          ? "6px"
                                          : "none",
                                    }}
                                    id={"labelId" + [i]}
                                    contentEditable={
                                      !(this.state.values[i].id == undefined
                                        ? false
                                        : this.state.values[i].id !=
                                        this.state.editedId)
                                        ? "plaintext-only"
                                        : false
                                    }
                                  >
                                    {this.state.values[i].label}
                                  </div>
                                </div>
                              </div>

                              <div
                                className="row"
                                style={{ marginTop: "2vw", marginLeft: "1vw" }}
                              >
                                <div className="col-sm-2" Align="left">
                                  <label>Answer Type:</label>
                                </div>
                                <div className="col-sm-8" Align="left">
                                  <label
                                    style={{
                                      marginLeft: "1vw",
                                      display:
                                        this.state.showOptionTextArea ||
                                          this.state.values[i].type == "SELECT" ||
                                          this.state.values[i].type ==
                                          "MULTISELECT"
                                          ? "block"
                                          : "none",
                                    }}
                                  >
                                    Options:
                                  </label>
                                  {/* <div 
                                  style={{display:
                                    this.state.showThresholdLimitLabel ||
                                      this.state.values[i].type == "INTEGER"
                                      ? "block"
                                      : "none",}}
                                  >
                                    <div
                                    style={{display : "flex"}}
                                    >
                                      <label
                                    style={{
                                      marginLeft: "1vw",
                                      padding : "0px 2vw",
                                    }}
                                  >
                                    Lower Threshold Limit :
                                  </label>
                                  <label
                                    style={{
                                      marginLeft: "1vw",
                                      padding : "0px 2vw",
                                    }}
                                  >
                                    Upper Threshold Limit :
                                  </label>
                                  
                                  </div>
                                  </div> */}
                                  {/* <label
                                    style={{
                                      marginLeft: "1vw",
                                      display:
                                        this.state.showSelectAllCheckBox ||
                                        this.state.values[i].type == "DAYSOFWEEK" 
                                          ? "block"
                                          : "none",
                                    }}
                                  >
                                    <input type="checkbox" onChange={this.handleSelectAllDays} /> Select All
                                  </label> */}

                                </div>
                                <div className="col-sm-2"></div>

                              </div>
                              <div
                                className="row"
                                style={{ marginLeft: "1vw" }}
                              >
                                <div className="col-sm-2">
                                  <select
                                    id={"answerTypeId" + [i]}
                                    className="answerType"
                                    onChange={(e) =>
                                      this.onHandleChangeAnswerType(i, e)
                                    }
                                    value={this.state.values[i].type}
                                    placeholder="Select Answer Type"
                                    disabled={
                                      this.state.values[i].id == undefined
                                        ? false
                                        : this.state.values[i].id !=
                                        this.state.editedId
                                    }
                                    style={{
                                      height: "30px",
                                      borderRadius: "4px",
                                      backgroundColor: "#F9F9FB",
                                      width: "9vw",
                                    }}
                                  >
                                    {this.answerTypeValues.map(
                                      (answerTypeKey) => (
                                        <option
                                          key={answerTypeKey}
                                          value={answerTypeKey["name"]}
                                        >
                                          {answerTypeKey["code"]}
                                        </option>
                                      )
                                    )}
                                    <option hidden value="Select Answer Type">
                                      Select Answer Type
                                    </option>
                                  </select>
                                </div>
                                <div className="col-sm-8">
                                  <div
                                    className="textarea"
                                    disabled={!this.state.user_editable}
                                    style={{
                                      display:
                                        (this.state.values[i].id == undefined ||
                                          this.state.values[i].id ==
                                          this.state.editedId) &&
                                          (this.state.values[i].type ==
                                            "MULTISELECT" ||
                                            this.state.values[i].type == "SELECT")
                                          ? "block"
                                          : "none",
                                      textAlign: "left",
                                      background: "white",
                                      height: "2.7em",
                                      resize: "none",
                                      paddingLeft: "2px",
                                      paddingTop: "6px",
                                      width: "75%",
                                      border:
                                        this.state.values[i].id == undefined ||
                                          this.state.values[i].id ==
                                          this.state.editedId
                                          ? "1px solid #D2D4DC"
                                          : "none",
                                      borderRadius:
                                        this.state.values[i].id == undefined ||
                                          this.state.values[i].id ==
                                          this.state.editedId
                                          ? "6px"
                                          : "none",
                                    }}
                                    id={"optionId" + [i]}
                                    contentEditable={
                                      !(this.state.values[i].id == undefined
                                        ? false
                                        : this.state.values[i].id !=
                                        this.state.editedId)
                                        ? "plaintext-only"
                                        : false
                                    }
                                  >
                                    {this.state.values[i].options}
                                  </div>
                                  <div style={{
                                    display: "flex",
                                    margin: "0px 1vw"
                                  }}>
                                    {/* For lower threshold value */}
                                    {/* {
                                  (this.state.values[i].id == undefined ||
                                    this.state.values[i].id ==
                                    this.state.editedId) &&
                                    (this.state.values[i].type == "INTEGER")
                                    ? <input
                                      type="number"
                                      className="threshold"
                                      id={"lowerThresholdId" + [i]}
                                      value={this.state.values[i].lowerThreshold}
                                      onChange={(e) => {
                                        this.state.values[i].lowerThreshold = e.target.value;
                                        this.setState(this.state);
                                      }}
                                      style={{
                                        // display:
                                        //   (this.state.values[i].id == undefined ||
                                        //     this.state.values[i].id ==
                                        //     this.state.editedId) &&
                                        //     (this.state.values[i].type == "INTEGER")
                                        //     ? "block"
                                        //     : "none",
                                        textAlign: "left",
                                        background: "white",
                                        height: "1.6em",
                                        resize: "none",
                                        paddingLeft: "2px",
                                        paddingTop: "6px",
                                        width: "15%",
                                        border:
                                          this.state.values[i].id == undefined ||
                                            this.state.values[i].id ==
                                            this.state.editedId
                                            ? "1px solid #D2D4DC"
                                            : "none",
                                        borderRadius:
                                          this.state.values[i].id == undefined ||
                                            this.state.values[i].id ==
                                            this.state.editedId
                                            ? "6px"
                                            : "none",
                                            margin :"0px 2vw"
                                      }} />
                                    :
                                    <div
                                      style={{
                                        // display: ((
                                        //   this.state.values[i].id ==
                                        //   this.state.editedId ) &&
                                        //   (this.state.values[i].type == "INTEGER")
                                        //   ? "none"
                                        //   : "block"),
                                        display:
                                        this.state.showThresholdLimitLabel ||
                                          this.state.values[i].type == "INTEGER"
                                          ? "block"
                                          : "none",
                                        marginLeft: "6vw"
                                      }}
                                    >
                                      {this.state.values[i].lowerThreshold}
                                    </div>
                                  } */}
                                    {/* For Upper threshold value */}
                                    {/* {(this.state.values[i].id == undefined ||
                                    this.state.values[i].id ==
                                    this.state.editedId) &&
                                    (this.state.values[i].type == "INTEGER")
                                    ? <input
                                      type="number"
                                      className="threshold"
                                      id={"thresholdId" + [i]}
                                      value={this.state.values[i].threshold}
                                      onChange={(e) => {
                                        this.state.values[i].threshold = e.target.value;
                                        this.setState(this.state);
                                      }}
                                      style={{
                                        // display:
                                        //   (this.state.values[i].id == undefined ||
                                        //     this.state.values[i].id ==
                                        //     this.state.editedId) &&
                                        //     (this.state.values[i].type == "INTEGER")
                                        //     ? "block"
                                        //     : "none",
                                        textAlign: "left",
                                        background: "white",
                                        height: "1.6em",
                                        resize: "none",
                                        paddingLeft: "2px",
                                        paddingTop: "6px",
                                        width: "15%",
                                        border:
                                          this.state.values[i].id == undefined ||
                                            this.state.values[i].id ==
                                            this.state.editedId
                                            ? "1px solid #D2D4DC"
                                            : "none",
                                        borderRadius:
                                          this.state.values[i].id == undefined ||
                                            this.state.values[i].id ==
                                            this.state.editedId
                                            ? "6px"
                                            : "none",
                                        margin : "0px 3vw"
                                      }} />
                                    :
                                    <div
                                      style={{
                                        // display: ((
                                        //   this.state.values[i].id ==
                                        //   this.state.editedId ) &&
                                        //   (this.state.values[i].type == "INTEGER")
                                        //   ? "none"
                                        //   : "block"),
                                        display:
                                        this.state.showThresholdLimitLabel ||
                                          this.state.values[i].type == "INTEGER"
                                          ? "block"
                                          : "none",
                                        marginLeft: "12vw"
                                      }}
                                    >
                                      {this.state.values[i].threshold}
                                    </div>
                                  } */}

                                  </div>
                                  <div
                                    style={{
                                      display:
                                        this.state.values[i].id == undefined ||
                                          this.state.values[i].id ==
                                          this.state.editedId
                                          ? "none"
                                          : "block",
                                    }}
                                  >
                                    <div
                                      style={{
                                        display:
                                          this.state.values[i].type ==
                                            "MULTISELECT"
                                            ? "block"
                                            : "none",
                                      }}
                                    >
                                      {this.state.values[i].optionsCopy.map(
                                        (optionItem) => (
                                          <span>
                                            <input
                                              type="checkbox"
                                              id="checkboxid"
                                            />
                                            &nbsp;
                                            {optionItem}
                                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                          </span>
                                        )
                                      )}
                                    </div>
                                    <div
                                      style={{
                                        display:
                                          this.state.values[i].type == "SELECT"
                                            ? "block"
                                            : "none",
                                      }}
                                    >
                                      {this.state.values[i].optionsCopy.map(
                                        (optionItem) => (
                                          <span>
                                            <input
                                              type="radio"
                                              name="selectCheck"
                                            />
                                            &nbsp;
                                            {optionItem}
                                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                          </span>
                                        )
                                      )}
                                    </div>
                                    <div
                                      style={{
                                        display:
                                          this.state.values[i].type == "BOOLEAN"
                                            ? "block"
                                            : "none",
                                      }}
                                    >
                                      <span>
                                        <input
                                          type="radio"
                                          name="booleanCheck"
                                        />
                                        &nbsp; Yes
                                      </span>
                                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                      <span>
                                        <input
                                          type="radio"
                                          name="booleanCheck"
                                        />
                                        &nbsp; No
                                      </span>
                                    </div>

                                    <div
                                      style={{
                                        display:
                                          this.state.values[i].type ==
                                            "DESCRIPTIVE"
                                            ? "block"
                                            : "none",
                                      }}
                                    >
                                      {this.state.values[i].optionsCopy.map(
                                        (optionItem) => (
                                          <div
                                            className="textarea"
                                            style={{
                                              border: "1px solid #D2D4DC",
                                              borderRadius: "2px",
                                              textAlign: "left",
                                              background: "white",
                                              height: "2.7em",
                                              resize: "none",
                                              paddingLeft: "2px",
                                              paddingTop: "6px",
                                              width: "75%",
                                            }}
                                            contentEditable={false}
                                            placeholder="Similar text area made available to patients"
                                          >
                                            {optionItem}
                                          </div>
                                        )
                                      )}
                                    </div>
                                  </div>
                                  <div className="col-sm-3" style={{ marginLeft: "60vw" }}>
                                    <button
                                      style={{
                                        backgroundColor: "#ffffff",
                                        border: "none",
                                        marginTop: "-9px",
                                        marginLeft: "-6px",
                                      }}
                                    >
                                      <img
                                        className="img-responsive"
                                        title={
                                          this.state.values[i].id == undefined ||
                                            this.state.values[i].id ==
                                            this.state.editedId
                                            ? "Save"
                                            : "Edit"
                                        }
                                        disabled={this.userDetails["userRole"] === "PHYSICIAN" &&
                                          JSON.parse(localStorage.getItem('user_details')).emailId !== localStorage.getItem("journalCreatedBy")}
                                        style={{
                                          marginTop: "6px",
                                          backgroundColor: this.userDetails["userRole"] === "PHYSICIAN" &&
                                            JSON.parse(localStorage.getItem('user_details')).emailId !== localStorage.getItem("journalCreatedBy")
                                            ? "#282a6596"
                                            : "#282a65",
                                          borderRadius: "5px",
                                          padding: "1px",
                                        }}
                                        src={
                                          this.state.values[i].id == undefined
                                            ? this.saveImageSrc
                                            : this.state.values[i].id !=
                                              this.state.editedId
                                              ? this.editImageSrc
                                              : this.saveImageSrc
                                        }
                                        onClick={this.userDetails["userRole"] === "PHYSICIAN" &&
                                          JSON.parse(localStorage.getItem('user_details')).emailId !== localStorage.getItem("journalCreatedBy") ? null :
                                          (e) => {
                                            this.state.values[i].id == undefined
                                              ? this.saveJournalItemInfoApi(i)
                                              : this.state.values[i].id ==
                                                this.state.editedId
                                                ? this.updateJournalItemApi(i)
                                                : this.makeCelledit(i);
                                          }}
                                      />
                                    </button>
                                    {this.state.values[i].id &&
                                      this.state.values[i].id !== "" && (
                                        <button
                                          title="Edit translations"
                                          style={{
                                            backgroundColor: "#ffffff",
                                            border: "none",
                                            marginLeft: "6px",
                                            cursor: "pointer",
                                            fontSize: "16px",
                                          }}
                                          onClick={() => {
                                            const fields = [
                                              { name: "label", label: "Label", rows: 1 },
                                              { name: "question", label: "Question", rows: 4 },
                                            ];
                                            const sourceFields = {
                                              label: this.state.values[i].label,
                                              question: this.state.values[i].question,
                                            };
                                            // Only include options field for SELECT and MULTISELECT types
                                            if (this.state.values[i].type === "SELECT" || this.state.values[i].type === "MULTISELECT") {
                                              fields.push({ name: "options", label: "Options (JSON)", rows: 4 });
                                              sourceFields.options = this.state.values[i].options;
                                            }
                                            this.setState({
                                              translationFor: {
                                                entityType: "journalItem",
                                                entityId: this.state.values[i].id,
                                                title:
                                                  this.state.values[i].label ||
                                                  this.state.values[i].question ||
                                                  "Journal item",
                                                fields: fields,
                                                sourceFields: sourceFields,
                                              },
                                            })
                                          }}
                                        >
                                          <img className="img-responsive" src="./assets/images/translate_white_24dp.svg" alt="translate" style={{ marginTop: "6px", backgroundColor: "#282a65", borderRadius: "5px", padding: "1px", width: "24px", height: "24px" }} />
                                        </button>
                                      )}
                                    <button
                                      style={{
                                        backgroundColor: "#ffffff",
                                        border: "none",
                                        marginTop: "-9px",
                                        marginLeft: "-6px",
                                      }}
                                      title="Delete"
                                    >
                                      <img
                                        className="img-responsive"
                                        src={
                                          "./assets/images/baseline_delete_white_24dp.png"
                                        }
                                        disabled={this.userDetails["userRole"] === "PHYSICIAN" &&
                                          JSON.parse(localStorage.getItem('user_details')).emailId !== localStorage.getItem("journalCreatedBy")}
                                        style={{
                                          marginTop: "6px",
                                          backgroundColor: this.userDetails["userRole"] === "PHYSICIAN" &&
                                            JSON.parse(localStorage.getItem('user_details')).emailId !== localStorage.getItem("journalCreatedBy")
                                            ? "#282a6596"
                                            : "#282a65",
                                          borderRadius: "5px",
                                          padding: "1px",
                                        }}
                                        onClick={this.userDetails["userRole"] === "PHYSICIAN" &&
                                          JSON.parse(localStorage.getItem('user_details')).emailId !== localStorage.getItem("journalCreatedBy") ? null : () =>
                                          this.handleDeleteQuestionButtonClick(
                                            this.state.values[i].id
                                          )
                                        }
                                      />
                                    </button>
                                  </div>
                                </div>

                              </div>
                              <div className="row">
                                <div className="col-sm-2"></div>
                                <div className="col-sm-8">
                                  <label
                                    style={{
                                      marginLeft: "1vw",
                                      display:
                                        (this.state.showOptionTextArea ||
                                          this.state.values[i].type ==
                                          "SELECT" ||
                                          this.state.values[i].type ==
                                          "MULTISELECT") &&
                                          (this.state.values[i].id == undefined ||
                                            this.state.values[i].id ==
                                            this.state.editedId)
                                          ? "block"
                                          : "none",
                                    }}
                                  >
                                    Add Comma separated options (Ex:
                                    option1,option2 etc)
                                  </label>


                                  {/* <label
                                    style={{
                                      marginLeft: "1vw",
                                      display:
                                        (this.state.showSelectAllCheckBox ||
                                          this.state.values[i].type ==
                                            "DAYSOFWEEK") &&
                                        (this.state.values[i].id == undefined ||
                                          this.state.values[i].id ==
                                            this.state.editedId)
                                          ? "block"
                                          : "none",
                                    }}
                                  >
                                    Add Comma separated Days (Ex:
                                    Sunday,Monday etc)
                                  </label> */}
                                </div>
                                <div className="col-sm-2"></div>
                              </div>
                            </div>
                          </div>
                          <hr />
                        </div>
                      ))}
                    </div>

                    <button
                      type="button"
                      className="btn btn-primary"
                      disabled={this.state.disableAddQuestionButton || this.userDetails["userRole"] === "PHYSICIAN" &&
                        JSON.parse(localStorage.getItem('user_details')).emailId !== localStorage.getItem("journalCreatedBy")}
                      style={{
                        width: "150px",
                        fontSize: "14px",
                        marginLeft: "3vw",
                        marginTop: "3vw",
                        marginBottom: "2vw",
                        // backgroundColor: this.state.disableAddQuestionButton ? "#666e77" : "#282a65",
                        backgroundColor: this.state.disableAddQuestionButton
                          ? "#666e77"
                          : (this.userDetails["userRole"] === "PHYSICIAN" &&
                            JSON.parse(localStorage.getItem('user_details')).emailId !== localStorage.getItem("journalCreatedBy"))
                            ? "#282a6596"
                            : "#282a65",

                        borderColor: this.state.disableAddQuestionButton ? "#666e77" : "#282a65"
                      }}
                      onClick={this.userDetails["userRole"] === "PHYSICIAN" &&
                        JSON.parse(localStorage.getItem('user_details')).emailId !== localStorage.getItem("journalCreatedBy") ? null :
                        this.handleAddQuestionButtonClick.bind(this)}
                    >
                      Add Question
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default JournalContent;



// WEBPACK FOOTER //
// src/my-jeeva/projectmgmt/JournalContent.js